import IRechargeLayer from "./IRechargeLayer";
import UIManager from "../../Shared/UIManager";
import { Global } from "../../Shared/Global";
import WebViewManager from "../../Shared/WebViewManager";
import Utils from "../../Shared/Utils";
import YinShangAccount from "../../Models/YinShangAccount";
import NetworkLogic from "../../Shared/NetworkLogic";
import Constant from "../../Shared/Constant";
import AddressManager from "../../Shared/AddressManager";
import Player from "../../Models/Player";

const {ccclass, property} = cc._decorator;

@ccclass
export default class RechargeAgentLayer extends IRechargeLayer {
    @property(cc.Layout)
    lyContent: cc.Layout = null

    @property(cc.Node)
    nodeTemplateItem: cc.Node = null

    yinShangAccountData = null;
    yinShangDomain = null;
    onLoad () {
        //this.nodeTemplateItem.parent = null
    }

    async start() {
        this.yinShangAccountData = await YinShangAccount.getYinShangAccount();

    }

    onDisable () {
        this.lyContent.node.destroyAllChildren()
    }

    onDestroy () {
        //this.nodeTemplateItem.destroy()
    }
    
    protected refreshData () {
        NetworkLogic.getYinshangDiscountConfig(function (data) {
            this.configs.forEach(cfg => {
                cfg.offerPercentage = parseFloat(data) * 100
                this.addItem(cfg)
            });
        }.bind(this))
    }

    private addItem (cfg) {
        let node = cc.instantiate(this.nodeTemplateItem)
        node.getChildByName("name").getComponent(cc.Label).string = cfg.name
        node["rechargeCfg"] = cfg
        node.parent = this.lyContent.node
        node.active = true;
        if (cfg.offerPercentage > 0) {
            cc.find("iconDiscount/discount", node).getComponent(cc.Label).string = "赠" + cfg.offerPercentage + "%"
        }else {
            cc.find("iconDiscount", node).active = false
        }

        //Utils.base64ImageLoad(node.getChildByName("head").getComponent(cc.Sprite),cfg.avatar)
        cc.loader.load({ url: this.yinShangDomain + cfg.avatar, type: "png" }, function (err, texture) {
            if (!err && node && node.isValid) {
                node.getChildByName("head").getComponent(cc.Sprite).spriteFrame = new cc.SpriteFrame(texture)
            }
        }.bind(this))
        //cc.log("====cfg:",cfg);
        Array.isArray(cfg.logoUrls) && cfg.logoUrls.forEach(url => {
            if  (!url) return;
            let iconNodes = node.getChildByName("iconNodes");
            for (let i =0;i < iconNodes.children.length;i++){
                let name = iconNodes.children[i].name   ;
                if (url.indexOf(name) != -1){
                    iconNodes.children[i].active = true;
                    break;
                }
            }
            //Utils.base64ImageLoad(sprite,url)
            // cc.loader.load({ url: this.yinShangDomain + url, type: "png" }, function (err, texture) {
            //     if (!err && iconNode && iconNode.isValid) {
            //         sprite.spriteFrame = new cc.SpriteFrame(texture)
            //         iconNode.setContentSize(iconNodes.height, iconNodes.height)
            //     }
            // }.bind(this))
        });
    }

    onBtnClick (event, userData) {
        if (userData === "recharge" || userData === "chat") {
            // 需要补全资料
            if (Player.getPy("visitorFillInfoTime").indexOf("3") !== -1 && Player.getPy("userType") === 2) {
                // 打开界面
                let hallUI = cc.find("Canvas/gameNode").getComponent("HallUI");
                hallUI.openChildUI(hallUI.pfbLoginCompleteInformation);
                return
            }
            
            let wvManager = cc.find("Canvas") && cc.find("Canvas").getComponent(WebViewManager)

            if (wvManager && this.yinShangAccountData) {
                let cfg = event.target.parent.rechargeCfg
                let url = ""
                if  (!this.yinShangDomain || !this.yinShangAccountData["accid"] || !this.yinShangAccountData["token"]) {
                    UIManager.showToastUI("银商数据错误", Global.ToastType.Warnning)
                    return;
                }
                if (userData === "recharge") {
                    this.yinShangDomain && (url = `${this.yinShangDomain}/index.html?account=${this.yinShangAccountData["accid"]}&token=${this.yinShangAccountData["token"]}&timestap=${new Date().getTime()}#/chat/p2p-${cfg.account.toLowerCase()}`)
                }else {
                    this.yinShangDomain && ( url = `${this.yinShangDomain}/index.html?account=${this.yinShangAccountData["accid"]}&token=${this.yinShangAccountData["token"]}&timestap=${new Date().getTime()}#/session`)
                }

                cc.log("银商地址：" + url)
                Utils.setOrientation("V")

                if (cc.sys.isMobile) {
                    wvManager.openAgentRecharge(url)
                }else {
                    cc.sys.openURL(url)
                }
            }else if (!this.yinShangAccountData) {

                UIManager.showToastUI("未登录银商", Global.ToastType.Warnning)
            }
        }
    }
}
